module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("IDENTITY")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Kimberly")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For we are God’s handiwork, created in Christ Jesus to do good works, which God prepared in advance for us to do.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("EPHESIANS 2:10")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("W")])]), _vm._v("ho am I? This is a question I ask myself on a fairly regular basis. When I am lost in doctors’ appointments, medical bills, and the daily grind of caring for someone with special needs, I often think, “There just has to be more to me than this!” And there is. There is so much more. If I’m being honest, though, sometimes it can feel like my identity is swallowed up in caring for my daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Shannon McNeil understands this all too well. She shared, “Even though I know I can work to make things different, my identity has morphed into [my children’s]. I am caretaker, therapist, nurse, insurance manager, chef, bathroom attendant, laundress, etc. I spend most of my time making sure they are well cared for and loved. I am realizing that I have been solely identifying myself as the mother of Waverly and Oliver who have Sanfilippo syndrome. And while I love being their mother and caring for their every need, I have to cultivate me.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn12",
      "id": "rfn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Cultivating who we are means understanding that being the parent of a child with special needs is just one part of us.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("To begin with, if you’re a fellow believer, we are first and forever children of God because of what Christ did for us on the cross. “Now if we are children, then we are heirs—heirs of God and co-heirs with Christ, if indeed we share in his sufferings in order that we may also share in his glory” (Rom. 8:17). Not only so, but “in all these things we are more than conquerors through him who loved us. For I am convinced that neither death nor life, neither angels nor demons, neither the present nor the future, nor any powers, neither height nor depth, nor anything else in all creation, will be able to separate us from the love of God that is in Christ Jesus our Lord” (vv. 37–39). I love those verses! We are not just conquerors in all these things; we are even "), _c('i', [_vm._v("more.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("First Corinthians 12 discusses our unique spiritual gifts and how each of us is a deeply unique and needed part of the body of Christ. I encourage you to read through this entire chapter and ask God to show you the gifts he has given you. One way to quickly get out of the mindset of a caregiver identity is to serve in an area of the church completely unrelated to that role. Be a greeter, sing in the choir, fold bulletins, clean up chairs, make meals, write encouraging notes—do whatever your energy and time will allow. Serving a role in the church body is both uplifting and affirming.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Spend some time reading through Psalm 139 as well. It is a beautiful picture of the thought and tenderness that God put into creating not only our children but us as well. We were planned. Not only that, but Ephesians 2:10 assures us that we were planned with a purpose in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("With these truths firmly in place, may we make the time to be more fully who God created us to be. Sometimes that means going to a lot of work to have our children cared for so we can have time to do something else, whether it’s ministry, work, or self-care. When we take the time to connect with God and with others, we remember that we are more than caregiving parents. We are children of God. We are more than conquerors, and dearly loved. We are each uniquely gifted and "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("enabled to serve the body of Christ in a role that, no matter how small, is truly needed. We were created with a purpose.")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Father God, you know my name. I’m written on the palm of your hands. Help me to see myself through your eyes and to have the courage to explore all you’ve created me to be and do for your glory. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What are other pieces to your identity, besides caregiver, that you’ve been missing?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What is one small way you can try to be more “you” this week?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What gifts do you think God gave you, and how can you better use them to serve him?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8353a2f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter08.vue
// module id = 105
// module chunks = 0